import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2d76d3b8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "my-open" }
const _hoisted_2 = { class: "my-open-wrapper" }
const _hoisted_3 = { class: "apply-info" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "open-matters-line-top" }, null, -1))
const _hoisted_5 = {
  key: 0,
  class: "open-matters-approve"
}
const _hoisted_6 = { class: "intro-item-label" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_8 = { class: "intro-item-value" }
const _hoisted_9 = {
  key: 1,
  class: "open-matters-apply"
}
const _hoisted_10 = { class: "form-item-box" }
const _hoisted_11 = {
  key: 2,
  class: "open-matters-line"
}
const _hoisted_12 = {
  key: 3,
  class: "flow-box"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Title = _resolveComponent("Title")!
  const _component_HeadTitle = _resolveComponent("HeadTitle")!
  const _component_ApplyInfoCard = _resolveComponent("ApplyInfoCard")!
  const _component_CaretDownOutlined = _resolveComponent("CaretDownOutlined")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_cascader = _resolveComponent("a-cascader")!
  const _component_a_date_picker = _resolveComponent("a-date-picker")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_Approval = _resolveComponent("Approval")!
  const _component_OpenButtonGroup = _resolveComponent("OpenButtonGroup")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_a_spin = _resolveComponent("a-spin")!

  return (_openBlock(), _createBlock(_component_a_spin, { spinning: $setup.Spinning }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_Title, { title: '我要开业' }),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_HeadTitle, { title: "申请人信息" }),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_ApplyInfoCard, {
              ApplicationInfo: _ctx.ApplicationInfo,
              ApplicationTime: _ctx.ApplicationTime
            }, null, 8, ["ApplicationInfo", "ApplicationTime"])
          ]),
          _hoisted_4,
          _createVNode(_component_HeadTitle, {
            title: '开业申请事项',
            style: {"margin-top":"24px"}
          }),
          (!$setup.editStatus)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.OpenMatters, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "intro-item-hd",
                    key: index
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item, (_item, _index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "intro-item",
                        key: _index
                      }, [
                        _createElementVNode("div", _hoisted_6, [
                          _createTextVNode(_toDisplayString(_item.label), 1),
                          _hoisted_7
                        ]),
                        _createElementVNode("div", _hoisted_8, "：" + _toDisplayString(_item.value), 1)
                      ]))
                    }), 128))
                  ]))
                }), 128))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createVNode(_component_a_form, {
                  ref: "FormRef",
                  model: $setup.FormData,
                  style: {"margin-top":"24px"},
                  labelAlign: "left",
                  "label-col": { style: { width: '116px' } }
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_10, [
                      _createVNode(_component_a_form_item, {
                        label: "公司类型",
                        name: "TypeName",
                        rules: [{ required: true, message: '请选择公司类型' }],
                        style: {"margin-right":"124px"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_select, {
                            placeholder: "请选择",
                            style: {"width":"290px","height":"32px"},
                            value: $setup.FormData.TypeName,
                            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => (($setup.FormData.TypeName) = $event)),
                            "show-search": "",
                            onChange: $setup.CompanyTypeListChange
                          }, {
                            suffixIcon: _withCtx(() => [
                              _createVNode(_component_CaretDownOutlined)
                            ]),
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.CompanyTypeList, (item, index) => {
                                return (_openBlock(), _createBlock(_component_a_select_option, {
                                  key: index,
                                  value: item.Val,
                                  filterV: item
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item.Key), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["value", "filterV"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["value", "onChange"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_form_item, {
                        label: "选定城市",
                        name: "CityName",
                        rules: [{ required: true, message: '请选择选定城市' }]
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_cascader, {
                            style: {"width":"290px","height":"32px"},
                            value: $setup.FormData.CityName,
                            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => (($setup.FormData.CityName) = $event)),
                            options: _ctx.CitysList,
                            placeholder: "请选择",
                            "expand-trigger": "hover",
                            pacement: "bottomLeft",
                            "display-render": $setup.displayRender,
                            props: {
                    emitPath: false,
                    value: 'Id',
                    label: 'Text',
                  },
                            fieldNames: {
                    label: 'Text',
                    value: 'Id',
                    children: 'Childs',
                  },
                            onChange: $setup.citysChange
                          }, null, 8, ["value", "options", "display-render", "onChange"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_form_item, {
                        label: "预计开业时间",
                        name: "ExpectOpenTime",
                        rules: [{ required: true, message: '请选择预计开业时间' }]
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_date_picker, {
                            style: {"width":"290px","height":"32px"},
                            valueFormat: "YYYY-MM-DD",
                            value: $setup.FormData.ExpectOpenTime,
                            "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => (($setup.FormData.ExpectOpenTime) = $event)),
                            placeholder: "请选择",
                            size: "large",
                            showToday: true
                          }, null, 8, ["value"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                }, 8, ["model"])
              ])),
          (!_ctx.ActionButtons.includes('100'))
            ? (_openBlock(), _createElementBlock("div", _hoisted_11))
            : _createCommentVNode("", true),
          (!_ctx.ActionButtons.includes('100'))
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createVNode(_component_HeadTitle, {
                  title: '审批流程',
                  class: "flow-box-headtitle"
                }),
                _createVNode(_component_Approval, {
                  id: $setup.WorkFlowId,
                  refresh: $setup.refresh,
                  isOpenPage: true
                }, null, 8, ["id", "refresh"])
              ]))
            : _createCommentVNode("", true)
        ]),
        (_ctx.ActionButtons.length)
          ? (_openBlock(), _createBlock(_component_OpenButtonGroup, {
              key: 0,
              "type-list": _ctx.ActionButtons,
              onClick: $setup.submitData
            }, null, 8, ["type-list", "onClick"]))
          : _createCommentVNode("", true),
        _createVNode(_component_a_modal, {
          class: "modal-dialog",
          bodyStyle: {
          width: '460px',
          height: '216px',
        },
          visible: _ctx.rejectedVisible,
          "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.rejectedVisible) = $event)),
          title: "驳回",
          onOk: $setup.submitRejectApply,
          onCancel: $setup.handleCancelRejectApply
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_textarea, {
              style: {"padding-left":"0"},
              value: _ctx.rejectResume,
              "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.rejectResume) = $event)),
              bordered: false,
              placeholder: "请填写驳回理由",
              maxlength: 2000,
              "auto-size": { minRows: 5, maxRows: 5 }
            }, null, 8, ["value"])
          ]),
          _: 1
        }, 8, ["visible", "onOk", "onCancel"]),
        _createVNode(_component_a_modal, {
          class: "modal-dialog",
          bodyStyle: {
          width: '460px',
          height: '216px',
        },
          visible: _ctx.recallVisible,
          "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.recallVisible) = $event)),
          title: "撤回理由",
          onOk: $setup.submitRecallApply,
          onCancel: $setup.handleCancelRecallApply
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_textarea, {
              style: {"padding-left":"0"},
              value: _ctx.recallResume,
              "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.recallResume) = $event)),
              bordered: false,
              placeholder: "请填写撤回理由",
              maxlength: 100,
              "auto-size": { minRows: 5, maxRows: 5 }
            }, null, 8, ["value"])
          ]),
          _: 1
        }, 8, ["visible", "onOk", "onCancel"])
      ])
    ]),
    _: 1
  }, 8, ["spinning"]))
}